import api from "../../services/api-configuration";

// Atölye (workshop/repair) module — purely additive, independent of custody (backend: /api/v1/workshop/*).

export const getWorkshopVehicles = async (warehouseId) =>
    (await api.post("/workshop/vehicles", { warehouse_id: warehouseId })).data;

export const getOpenCustodyDamage = async (chassisNo) =>
    (await api.post("/workshop/openDamage", { chassis_no: chassisNo })).data;

export const getWorkshopItemsByChassis = async (chassisNo) =>
    (await api.post("/workshop/byChassis", { chassis_no: chassisNo })).data;

export const createWorkshopItem = async (data) => (await api.post("/workshop/items", data)).data;

export const fixWorkshopItem = async (id, fixNote) => (await api.post("/workshop/fix", { id, fix_note: fixNote })).data;

// Files need the auth token, so they're fetched as blobs, not via a plain <a href> (see devir-teslim/api.js).
export const openWorkshopFile = async (path) => {
    const res = await api.get("/custody/file", { params: { path }, responseType: "blob" });
    window.open(URL.createObjectURL(res.data), "_blank");
};

export const addWorkshopItemFile = async (itemId, kind, file) => {
    const form = new FormData();
    form.append("item_id", itemId);
    form.append("kind", kind);
    form.append("file", file);
    return (await api.post("/workshop/addFile", form, { headers: { "Content-Type": "multipart/form-data" } })).data;
};
